import styled from 'styled-components';
import { Error } from '../../CustomInput/style';

export const AnswerTop = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 16px;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  margin-bottom: 24px;

  @media ${(props) => props.theme.device.tabletL} {
    flex-wrap: wrap;
  }

  @media ${(props) => props.theme.device.mobileL} {
    align-items: start;
    flex-direction: column;

    > div,
    .d-flex {
      width: 100%;
    }
  }
`;

export const DurationWrapper = styled.div`
  min-width: max-content;
`;

export const CustomBtn = styled.div`
  padding: 7px;
  border-radius: 4px;
  background: ${(props) => props.theme.colors.link};
  color: ${(props) => props.theme.colors.white};
  cursor: pointer;
  width: 50px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  position: relative;

  &.disabled {
    background: ${(props) => props.theme.colors.btnDisabledBg};
    color: ${(props) => props.theme.colors.textSecondary};
    cursor: not-allowed;
  }
  &.last {
    margin-left: -5px;
  }
`;

export const Value = styled.div`
  background: #f7f7f7;
  display: inline;
  min-width: 100px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: -5px;
`;

export const PercentageWrapper = styled.div`
  position: relative;

  .percentage {
    position: absolute;
    right: 7px;
    top: 7px;
  }

  ${Error} {
    position: absolute;
    width: 200%;
  }
`;
